import "./widgets-core18.css";
import { h as S, inject as j, defineComponent as z, useCssVars as H, unref as f, computed as I, openBlock as x, createElementBlock as $, withModifiers as F, normalizeClass as D, createBlock as L } from "vue";
import { a as P, i as R, b as G, k as U, r as M } from "./chunks/key.BnZ-8sdC.js";
import { u as V } from "./chunks/useTheme.L4REnSCw.js";
import { _ as X } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
function y(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var h = function() {
  return P.Date.now();
}, q = /\s/;
function J(e) {
  for (var t = e.length; t-- && q.test(e.charAt(t)); )
    ;
  return t;
}
var Q = /^\s+/;
function Y(e) {
  return e && e.slice(0, J(e) + 1).replace(Q, "");
}
var Z = "[object Symbol]";
function K(e) {
  return typeof e == "symbol" || R(e) && G(e) == Z;
}
var B = NaN, ee = /^[-+]0x[0-9a-f]+$/i, te = /^0b[01]+$/i, ne = /^0o[0-7]+$/i, re = parseInt;
function E(e) {
  if (typeof e == "number")
    return e;
  if (K(e))
    return B;
  if (y(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = y(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Y(e);
  var n = te.test(e);
  return n || ne.test(e) ? re(e.slice(2), n ? 2 : 8) : ee.test(e) ? B : +e;
}
var ie = "Expected a function", oe = Math.max, ae = Math.min;
function se(e, t, n) {
  var s, r, l, a, i, c, d = 0, g = !1, u = !1, b = !0;
  if (typeof e != "function")
    throw new TypeError(ie);
  t = E(t) || 0, y(n) && (g = !!n.leading, u = "maxWait" in n, l = u ? oe(E(n.maxWait) || 0, t) : l, b = "trailing" in n ? !!n.trailing : b);
  function C(o) {
    var m = s, p = r;
    return s = r = void 0, d = o, a = e.apply(p, m), a;
  }
  function A(o) {
    return d = o, i = setTimeout(v, t), g ? C(o) : a;
  }
  function O(o) {
    var m = o - c, p = o - d, _ = t - m;
    return u ? ae(_, l - p) : _;
  }
  function k(o) {
    var m = o - c, p = o - d;
    return c === void 0 || m >= t || m < 0 || u && p >= l;
  }
  function v() {
    var o = h();
    if (k(o))
      return w(o);
    i = setTimeout(v, O(o));
  }
  function w(o) {
    return i = void 0, b && s ? C(o) : (s = r = void 0, a);
  }
  function N() {
    i !== void 0 && clearTimeout(i), d = 0, s = c = r = i = void 0;
  }
  function W() {
    return i === void 0 ? a : w(h());
  }
  function T() {
    var o = h(), m = k(o);
    if (s = arguments, r = this, c = o, m) {
      if (i === void 0)
        return A(c);
      if (u)
        return clearTimeout(i), i = setTimeout(v, t), C(c);
    }
    return i === void 0 && (i = setTimeout(v, t)), a;
  }
  return T.cancel = N, T.flush = W, T;
}
const ce = (e, t) => {
  const n = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M13.03 4.47a.75.75 0 010 1.06L8.56 10l4.47 4.47a.75.75 0 11-1.06 1.06l-5-5a.75.75 0 010-1.06l5-5a.75.75 0 011.06 0z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const l = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, i) => ({
    ...a,
    [i.name]: i.value
  }));
  return S(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, le = (e, t) => {
  const n = "http://www.w3.org/2000/svg", r = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, r.appendChild(a);
  }
  const l = Array.from((r == null ? void 0 : r.attributes) ?? []).reduce((a, i) => ({
    ...a,
    [i.name]: i.value
  }));
  return S(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: r.innerHTML
    }
  );
}, ue = () => j(U, {
  t: (t, n) => M(t, n) || t,
  tc: (t, n, s) => M(t, s) || t
}), fe = ["aria-label"], de = /* @__PURE__ */ z({
  __name: "ActionButton",
  props: {
    type: { default: "close" },
    color: {},
    overColor: {},
    size: { default: "medium" }
  },
  emits: ["action-click"],
  setup(e, { emit: t }) {
    H((d) => ({
      "7f1e9edf": a.value,
      "4c978f2a": i.value,
      "5b628c32": f(r).borderRadius
    }));
    const n = e, s = t, r = V(), { t: l } = ue(), a = I(() => n.color ?? "#333"), i = I(() => n.overColor ?? r.actionColor.base), c = se(() => {
      s("action-click");
    }, 200, { leading: !0, trailing: !1 });
    return (d, g) => (x(), $("button", {
      type: "button",
      onMousedown: g[0] || (g[0] = F(
        //@ts-ignore
        (...u) => f(c) && f(c)(...u),
        ["left"]
      )),
      onClick: g[1] || (g[1] = //@ts-ignore
      (...u) => f(c) && f(c)(...u)),
      "data-testid": "action-trigger",
      "aria-label": n.type === "close" ? f(l)("Close") : f(l)("Back"),
      class: D(["actionTrigger", `actionTrigger--${n.size}`])
    }, [
      d.type === "close" ? (x(), L(f(le), {
        key: 0,
        class: "actionTrigger__icon close"
      })) : (x(), L(f(ce), {
        key: 1,
        class: "actionTrigger__icon back"
      }))
    ], 42, fe));
  }
}), Ce = /* @__PURE__ */ X(de, [["__scopeId", "data-v-dff25ba4"]]);
export {
  Ce as default,
  ue as u
};
//# sourceMappingURL=widgets-core.es20.js.map
